export default "__VITE_ASSET__B84MR7sl__"